<template>
<div v-if="showComponent" >
  <h4>{{title}}</h4>
  <font-awesome-icon
    id="font-awesome-icon-edit"
    icon="edit"
    size="sm"
    class="clickable float-right mt-1"
    v-if="showEditButton"
    @click="$emit('edit-button-clicked')"
  />
  <template v-if="type === 'single'">
    <label  class="d-block">{{subtitle}} <small v-if="required">*</small></label>
    <div class="clearfix d-inline-block" >
    <label :for="`checkbox-single-${id}`" :style="size==='sm'? 'font-size:13px' : '' || size==='lg'? 'font-size:19px' : '' " :class="labelPosition === 'right' ? 'mr-2': ''" v-text="labelSingle ? labelSingle : status" class="checkbox_label"></label>
    <b-form-checkbox
        :id="`checkbox-single-${id}`"
        v-model="status"
        name="checkbox-single"
        :value="checkValue"
        :unchecked-value="uncheckedValue"
        :class="labelPosition === 'right' ? 'float-right': 'float-left'"
        :size='size'
        :switch="variant === 'switch' ? 'switch' : false"
        @input="onInput($event)"
        :state="v.$error ? state : null"
        :disabled="disabled"
      />
    </div>
    <br>
    <!-- {{ status }} -->
  </template>

  <template v-if="type === 'multiple'">
     <label  class="d-block">{{subtitle}} <small v-if="required">*</small></label>
    <b-form-group v-slot="{ ariaDescribedby }" >
      <b-form-checkbox-group
        :id="`checkbox-group-${id}`"
        v-model="selected"
        :options="options"
        :aria-describedby="ariaDescribedby"
        name="flavour-1"
        :size='size'
        :stacked="orientation === 'stacked' ? true : false"
        :switches="variant === 'switch' ? 'switches' : false"
        @input="onInput($event)"
        :state="v.$error ? state : null"
      >
      <!-- <template v-if="required">
        <b-form-invalid-feedback :state="state" v-if='v.$error'>{{ $t(invalidText) }}</b-form-invalid-feedback>
        <b-form-valid-feedback :state="state">{{ $t(validText) }}</b-form-valid-feedback>
      </template> -->
      </b-form-checkbox-group>
    </b-form-group>
     <!-- {{ selected }} -->
  </template>
  <p class="invalid-feedback d-block" v-if="'required' in v && !v.required && v.$dirty">{{ $t('field_required')}} </p>
</div>
</template>

<script>
// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  data () {
    return {
      status: false,
      selected: []
    }
  },
  props: {
    checkValue: {
      type: [Boolean, String],
      default: true
    },
    uncheckedValue: {
      type: [Boolean, String],
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    labelSingle: {
      type: String,
      default: 'Label single'
    },
    labelPosition: {
      type: String,
      default: 'left'
    },
    type: {
      type: String,
      default: 'single'
    },
    size: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: ''
    },
    orientation: {
      type: String,
      default: 'inline'
    },
    options: {
      type: Array,
      default: () => []
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    singleSelected: {
      type: Boolean,
      default: false
    },
    v: {
      type: Object,
      default: () => ({})
    },
    invalidText: {
      type: String
    },
    validText: {
      type: String
    },
    value: {
      type: [String, Boolean, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.status = val
      }
    },
    singleSelected: {
      immediate: true,
      handler (val, oldVal) {
        if (val === true) {
          this.status = this.checkValue
        } else {
          this.status = this.uncheckedValue
        }
      }
    },
    options: {
      immediate: true,
      handler (val, oldVal) {
        let result = this.options.filter(item => item.checked === true)
        result = result.map(function (r) { return r.value })
        this.selected = result
      }
    },
    // Al mostrar el componente retorno su uncheckedValue
    showComponent (val) {
      if (val) {
        this.$emit('input', this.uncheckedValue)
      }
    }
  },
  computed: {
    state () {
      if (this.type === 'single') {
        return this.status === this.checkValue
      } else if (this.type === 'multiple') {
        return this.selected.length > 0
      }
    },
    required () {
      return this.v.required !== undefined
    }
  },
  methods: {
    onInput (value) {
      if (this.type === 'single') {
        this.$emit('input', this.status)
      } else if (this.type === 'multiple') {
        this.$emit('input', this.selected.sort())
      }
    }
  },
  created () {
    // PROBAR ESTA LINEA
    this.status = !!this.value
    if (this.type === 'single' && !this.labelSingle) {
      if (this.singleSelected === true) {
        this.status = this.checkValue
      } else {
        this.status = this.uncheckedValue
      }
    }

    // TODO: Probar esta linea
    // En edit mode y checkboxs multiples, no se precargarn los datos
    // Pasar a watch por unica vez, por si fuera asincrono
    if (this.value) {
      this.selected = this.value
    }
  }
}
</script>

<style lang="sass" scoped>
.checkbox_label
  padding-top: 3px
</style>
